/**
 * Test IDs for QA automation.
 */
export const testIds = {
  uptickFormStorageFacilitySelector: "uptick-form-storage-facility-selector",
  uptickFormStorageFacilityOption: "uptick-form-storage-facility-option",
} as const;
